export default theme => ({
  fullWidth: {
    width: '100%'
  },
  search: {
    width: '100%',
    [theme.breakpoints.up('xl')]: {
      // minWidth: 996,
    },
    '& input': {
      padding: 6,
      height: 31,
      boxSizing: 'border-box',
      // color: theme.palette.textColor.grey
      opacity: '.9',
    }
  },
  searchIcon: {
    color: theme.palette.textColor.secondary,
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: 8
  },
});
